/**
 * @generated SignedSource<<82d9264573506c14f43b254b0acba572>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type PhoneNumberPageMutation$variables = {
  creditApplicationId: string;
  e164: string;
};
export type PhoneNumberPageMutation$data = {
  readonly fraudAlertChallenge: {
    readonly success: boolean;
  };
};
export type PhoneNumberPageMutation = {
  response: PhoneNumberPageMutation$data;
  variables: PhoneNumberPageMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'creditApplicationId',
      },
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'e164',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            fields: [
              {
                kind: 'Variable',
                name: 'creditApplicationId',
                variableName: 'creditApplicationId',
              },
              {
                kind: 'Variable',
                name: 'e164',
                variableName: 'e164',
              },
            ],
            kind: 'ObjectValue',
            name: 'q',
          },
        ],
        concreteType: 'FraudAlertChallengeResponse',
        kind: 'LinkedField',
        name: 'fraudAlertChallenge',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'PhoneNumberPageMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'PhoneNumberPageMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '78fbd5c8d8133d9969f258d767d37ccf',
      id: null,
      metadata: {},
      name: 'PhoneNumberPageMutation',
      operationKind: 'mutation',
      text: 'mutation PhoneNumberPageMutation(\n  $creditApplicationId: String!\n  $e164: String!\n) {\n  fraudAlertChallenge(q: {creditApplicationId: $creditApplicationId, e164: $e164}) {\n    success\n  }\n}\n',
    },
  };
})();

(node as any).hash = '2b15fccad25cb9453ad682da2990a17f';

export default node;
